import { PageRequest } from '@/core/request/PageRequest';
import { UploadFile } from 'antd';
import {
  EmissionEnvironmentEnum,
  TypeOfDigitalCertificateEnum,
} from '../../invoice/settings/Settings.types';
import { Address } from '../../_shared/Address';
import { Contact } from '../../_shared/Contact';

export enum CompanyType {
  Funilaria = 'FUNILARIA',
  Mecanica = 'MECANICA',
}

export interface Company extends CompanyUpdateRequest {
  id: number;
  boschCompanyCode?: string;
  capsCode?: string;
}

export interface CompanyReduced {
  cnpj: string;
  id: number;
  name: string;
  nickname: string;
  main: boolean;
  active: boolean;
  blocked: boolean;
  capsCode?: string;
  capsSurname?: string;
}

export interface PageResultCompanyReduced {
  nextToken: string;
  data: CompanyReduced[];
  maxCompanies: number;
  totalCompanies: number;
}

export interface CompanyCreateRequest {
  active: boolean;
  cnae: string;
  cnpj: string;
  comments: string;
  companyAddress: Address;
  companyType: CompanyType;
  contactList?: Contact[];
  logo: string;
  municipalRegistration: string;
  name: string;
  nickName: string;
  stateRegistration: string;
  taxRegimeId: number;
  webSite: string;
  pecaAiContactEmail?: string;
  pecaAiContactName?: string;
  pecaAiContactPhone?: string;
  canReceiveScheduleRequest: boolean;
  notificationEmail?: string;
  main: boolean;
}

export interface CompanyFormValues {
  name: string;
  nickName: string;
  companyType: CompanyType;
  cnae: string;
  webSite: string;
  municipalRegistration: string;
  stateRegistration: string;
  taxRegimeId: number;
  companyAddress: Address;
  comments: string;
  logo: UploadFile[] | null;
  contactList: Contact[];
  cnpj: string;
  pecaAiContactEmail?: string;
  pecaAiContactName?: string;
  pecaAiContactPhone?: string;
  canReceiveScheduleRequest: boolean;
  main: boolean;
}

export interface CompanyUpdateRequest {
  id: number;
  active: boolean;
  blocked: boolean;
  cnae: string;
  cnpj: string;
  comments: string;
  companyAddress: Address;
  companyType: CompanyType;
  contactList: Contact[];
  logo?: string | null;
  mainAreaId: number;
  matrixId: number;
  municipalRegistration: string;
  name: string;
  nickName: string;
  region: string;
  stateRegistration: string;
  taxRegimeId: number;
  webSite: string;
  pecaAiContactEmail?: string;
  pecaAiContactName?: string;
  pecaAiContactPhone?: string;
  alwaysGenerateActivityByWorkOrder: boolean;
  canReceiveScheduleRequest: boolean;
  notificationEmail?: string;
  maxCompanies: boolean;
  totalCompanies: boolean;
  main: boolean;
}

export interface CompanyLogoUpdateRequest {
  companyId: number;
  file: File;
}

export interface CompanyLogoUpdateResponse {
  filePath: string;
  name: string;
}

export type CompanyUpdateForm = Omit<CompanyUpdateRequest, 'logo'> & {
  logo?: UploadFile[] | null;
};

export interface ListCompaniesQuery extends PageRequest {
  search?: string;
  active?: boolean;
  cnpj?: string;
  companyType?: CompanyType;
  name?: string;
  billingIntegration?: boolean;
  main?: boolean;
  filterActiveSped?: boolean;
}

export interface ListCompaniesQueryReduced extends ListCompaniesQuery {
  isCompanyFilter?: boolean;
  includeBlocked?: boolean;
}
export interface CompanyTerms {
  acquittanceTerms: string;
  lgpdTerms: string;
  partsSuppliedTerms: string;
  permanenceDeclaration: string;
  serviceOrderSigningStatement: string;
  warrantyTerms: string;
  plateSealCutTerms: string;
}

interface InvoiceNoteTypeInterface {
  issueInvoice: boolean;
  issueConsumerInvoice: boolean;
  issueTaxCoupon: boolean;
  issueCombinedInvoice: boolean;
}

interface IssueInvoiceInterface {
  model: string;
  series: string;
  cfopId: number;
  lastNfeNumber: string;
  generateInvoice: boolean;
  generateTag: boolean;
  idCsrt: string;
  securityCode: string;
}

export interface CompanyInvoiceConfigurationInterface
  extends InvoiceNoteTypeInterface,
    IssueInvoiceInterface {
  emissionEnvironment: EmissionEnvironmentEnum;
  typeOfDigitalCertificate: TypeOfDigitalCertificateEnum;
  certificatePassword: string;
  useUnife: boolean;
}

export interface CompanyPecaAiResponse {
  redirectUrl: string;
  token: string;
}

export interface CompanyProvider {
  provider: string;
}

export interface CompanyPecaAiFormValues {
  pecaAiContactEmail?: string;
  pecaAiContactName?: string;
  pecaAiContactPhone?: string;
}

export interface CompanySettingsFormValues {
  id: number;
  isInstallmentFree?: boolean;
  shouldUpdateDueDateBasedOnCreationDate?: boolean;
  michelinIntegration?: boolean;
  isOutputCfopBlockedInPurchaseImport?: boolean;
  allowNegativeLiquidValueInPayables?: boolean;
  allowInformSellPriceInPurchaseItem?: boolean;
  shouldProvideCancellationReasonInPurchase?: boolean;
}
export interface CompanySettingsInterface extends CompanySettingsFormValues {
  companyId: number;
}

export interface CompanySettingsResponse extends CompanySettingsInterface {
  isAuthorizedToAccessPecaAi: boolean;
  isAuthorizedToAccessProParts: boolean;
}
